/*
 * Block and unblock UI elements with a spinner. Useful to prevent user interaction while loading content.
 * Thin wrapper over c2.spinners kept for API parity with the deprecated c2Archive/block.js.
 */

(function (c2) {
  'use strict';

  function block(el, useInlineCss) {
    if (useInlineCss) {
      // This rendered a multi-dot spinner instead of the spinner image
      const spinnerTemplate = document.getElementById('spinner-line')
      const spinnerCopy = spinnerTemplate.content.firstElementChild.cloneNode(true);
      spinnerCopy.classList.add('blocker-fade','spinner-box-block')
      spinnerCopy.classList.remove('spinner-box-inline')
      $(spinnerCopy).appendTo($(el));
    } else {
      c2.spinners.showSpinner({
        selector: el || '#content',
        fade: true,
      });
    }
  }

  function unblock(el) {
    c2.spinners.hideSpinner({
      selector: el || '#content',
      fade: true
    });
  }

  c2.block = {
    block: block,
    unblock: unblock
  };
})(window.c2);
